module.exports = __webpack_public_path__ + "img/avatar7.55099377.png";